module.exports = __webpack_public_path__ + "img/health17_7-9-2021.dbb32a67.jpg";